import _Skeleton from "./Skeleton.mjs";
import { withInstall } from "../utils/index.mjs";
const Skeleton = withInstall(_Skeleton);
var stdin_default = Skeleton;
import { skeletonProps } from "./Skeleton.mjs";
export {
  Skeleton,
  stdin_default as default,
  skeletonProps
};
